module.exports = __webpack_public_path__ + "nova_logo_omni.bd1d472dd7dae6057b6a.svg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/assets/nova_logo_omni.svg
// module id = ../../../../../src/assets/nova_logo_omni.svg
// module chunks = main